import * as React from 'react';
import { SmartRow } from '../../types';

interface Props {
  row: SmartRow;
}

export const Restrictions: React.FC<Props> = (props) => {
  const { row } = props;

  switch (row.type) {
    case 'placeholder':
    case 'no-data':
      return null;
    case 'alert':
      return <span>-</span>;
    default:
      break;
  }

  const { terminalRestrictions } = row;
  return <span className="whitespace-normal">{terminalRestrictions}</span>;
};
Restrictions.displayName = 'SmartPerDiem.Table.Cell.Restrictions';
